/**
 * The one piece of markup a post's text may carry: a link.
 *
 * `[label](/path)` is a page of ours — rendered through `Link`, so it stays in
 * the reader's language and is a real `<a href>` in the prerendered HTML.
 * `[label](https://…)` is a source, opened in a new tab. Nothing else is
 * parsed: bold, italics and headings are the layout's job, not the text's.
 */
import { Fragment, type ReactNode } from "react";
import { Link } from "@/components/link";

export const LINK = /\[([^\]]+)\]\(([^)\s]+)\)/g;

export function Rich({ text }: { text: string }): ReactNode {
  const out: ReactNode[] = [];
  let last = 0;
  for (const m of text.matchAll(LINK)) {
    const [whole, label, href] = m;
    out.push(text.slice(last, m.index));
    out.push(
      href!.startsWith("/") ? (
        <Link key={m.index} to={href!} className="font-medium text-primary underline-offset-4 hover:underline">
          {label}
        </Link>
      ) : (
        <a key={m.index} href={href} target="_blank" rel="noopener" className="font-medium text-primary underline-offset-4 hover:underline">
          {label}
        </a>
      ),
    );
    last = m.index! + whole.length;
  }
  out.push(text.slice(last));
  return <>{out.map((part, i) => <Fragment key={i}>{part}</Fragment>)}</>;
}
